<template>
  <v-app>
    <TheAppBar app />
    <v-main>
      <router-view />
    </v-main>
    <TheSnackBar app />
    <v-footer app>
      <v-spacer />
      <strong>{{ version }}</strong>
    </v-footer>
  </v-app>
</template>

<script>
import TheAppBar from "./components/Base/TheAppBar";
import TheSnackBar from "./components/Base/TheSnackBar";
export default {
  name: 'App',
  components: {
    TheSnackBar,
    TheAppBar
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    };
  }
};
</script>
